import { BASE_API } from "../utils/constants";
import { firstError } from "./area";

export async function getTablesApi(token) {
  try {
    const url = `${BASE_API}/api/tables/`;
    const params = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function addTableApi(data, token) {
  try {
    const url = `${BASE_API}/api/tables/`;
    const params = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    const response = await fetch(url, params);
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(firstError(result) || "No se pudo guardar la mesa");
    return result;
  } catch (error) {
    throw error;
  }
}

export async function updateTableApi(id, data, token) {
  try {
    const url = `${BASE_API}/api/tables/${id}/`;
    const params = {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    const response = await fetch(url, params);
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(firstError(result) || "No se pudo guardar la mesa");
    return result;
  } catch (error) {
    throw error;
  }
}

export async function deleteTableApi(id, token) {
  try {
    const url = `${BASE_API}/api/tables/${id}/`;
    const params = {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

// Con token (Admin) devuelve también current_guests; sin token, la versión
// pública de la mesa.
export async function getTableApi(idTable, token) {
  try {
    const url = `${BASE_API}/api/tables/${idTable}/`;
    const response = await fetch(
      url,
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
    );
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function getTableByNumberApi(numberTable) {
  try {
    const tableFilter = `number=${numberTable}`;

    const url = `${BASE_API}/api/tables/?${tableFilter}`;
    const response = await fetch(url);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

// Entrada del Cliente: valida número + código. Devuelve la mesa ({id, number})
// o null si no coinciden (mismo resultado si la mesa no existe).
export async function verifyTableAccessApi(number, code) {
  try {
    const url = `${BASE_API}/api/tables/verify/`;
    const params = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ number, code }),
    };
    const response = await fetch(url, params);
    if (!response.ok) return null;
    return await response.json();
  } catch (error) {
    throw error;
  }
}

export async function regenerateTableCodeApi(id, token) {
  try {
    const url = `${BASE_API}/api/tables/${id}/regenerate-code/`;
    const params = {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    };
    const response = await fetch(url, params);
    return await response.json();
  } catch (error) {
    throw error;
  }
}

// Personas del grupo que está en la mesa (cuadro "cantidad de personas").
export async function setTableGuestsApi(id, guests, token, waiter) {
  const response = await fetch(`${BASE_API}/api/tables/${id}/`, {
    method: "PATCH",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    // El mesero (id de un usuario) se anota junto con las personas ("Mesero: Carlos").
    body: JSON.stringify({
      current_guests: guests,
      ...(waiter !== undefined ? { current_waiter_user: waiter } : {}),
    }),
  });
  if (!response.ok) throw new Error(`No se pudo guardar (${response.status})`);
  return await response.json();
}

// Cliente del grupo que está en la mesa ("Selecciona un cliente"); null lo quita.
export async function setTableCustomerApi(id, customerId, token) {
  const response = await fetch(`${BASE_API}/api/tables/${id}/`, {
    method: "PATCH",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    body: JSON.stringify({ current_customer: customerId }),
  });
  if (!response.ok) throw new Error(`No se pudo guardar (${response.status})`);
  return await response.json();
}

// Delivery: canal (PedidosYa, Rappi…) y costo de envío del pedido en curso.
export async function setTableDeliveryApi(id, channel, fee, token) {
  const response = await fetch(`${BASE_API}/api/tables/${id}/`, {
    method: "PATCH",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    body: JSON.stringify({ current_delivery_channel: channel, current_delivery_fee: fee }),
  });
  if (!response.ok) throw new Error(`No se pudo guardar (${response.status})`);
  return await response.json();
}
